import { getActiveChainFromState } from '#/reduxState/exchange/exchangeActiveChain';
import {
  Chains,
  chainsMap,
} from '#/reduxState/exchange/exchangeActiveChainUtils';

import { ChainConfig, ChainsFromConfig } from './configType';

import config from './index';

const configIsChains = (
  stateChain?: Chains | ChainsFromConfig
): Chains | undefined =>
  Object.keys(chainsMap).some(key => stateChain === key)
    ? (stateChain as Chains)
    : undefined;

export const getCurrentStateChainConfig = (
  stateChain?: Chains | ChainsFromConfig
): ChainConfig => {
  const activeChain = stateChain || getActiveChainFromState();
  const activeChainOrUndef = configIsChains(activeChain);
  const chainConfig =
    config.chains[
      activeChainOrUndef
        ? chainsMap[activeChainOrUndef]?.configProp
        : (activeChain as ChainsFromConfig)
    ];
  return chainConfig
    ? chainConfig
    : (function () {
        throw new Error('Unknown chain');
      })();
};

/** keywords: getBlockExplorerWalletUrl */
export const getBlockExplorerAddressUrl = (
  address: string,
  chain: Chains | ChainConfig
) => {
  return `${
    (typeof chain === 'string' ? getCurrentStateChainConfig(chain) : chain)
      .chainBlockExplorer || 'unknown-network'
  }/address/${address}`;
};

export const getBlockExplorerTransactionUrl = (
  transactionHash: string,
  chain: Chains | ChainConfig | ChainsFromConfig
) => {
  return `${
    (typeof chain === 'string' ? getCurrentStateChainConfig(chain) : chain)
      .chainBlockExplorer || 'unknown-network'
  }/tx/${transactionHash}`;
};

// https://mumbai.polygonscan.com/token/0x66715dd22a2aD905D05d1DEa01deB361337013C1#balances
// export const getBlockExplorerTokenUrl = (address: string, chain: Chains) => {
//   return `${
//     getCurrentStateChainConfig(chain).chainBlockExplorer || 'unknown-network'
//   }/token/${address}`;
// };

/** To debug pagination limits more easily, we can specify URL hash parameter to override per page count */
export const getPaginationPerPageLimit = (defaultLimit: number): number => {
  if (!window?.location?.hash) {
    return defaultLimit;
  }
  const [prop, value] = window.location.hash.split('=');
  if (prop === '#pageLimit') {
    return Number(value) || defaultLimit;
  }
  return defaultLimit;
};

/**
 * Chain on which rewards and payouts are credited
 * Note: Referrals are credited as on-chain automatic deposit.
 */
export const getRewardsChain = (): {
  chainCode: Chains;
  configProp: ChainsFromConfig;
  config: ChainConfig;
} => {
  return {
    chainCode: 'katanaEVMChain',
    configProp: 'katanaChain',
    config: config.chains.katanaChain,
  };
};
